function SectionVisit({ sectionRef }) {
    return (
        <div ref={sectionRef} className="section-visit px-[20px] md:px-[50px] lg:px-[70px] xl:px-[100px] bg-[#F1F8FF]">
            <h3 className="text-sky-500 md:text-xl lg:text-2xl xl:text-3xl font-extrabold">Spot Us in Your City! Visit the Nearest FamilyMart!</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 items-center mt-5">
                <div><h4 className="text-sky-500 text-lg lg:text-xl xl:text-2xl font-extrabold text-center py-2 md:py-5">Jakarta</h4></div>
                <div><h4 className="text-sky-500 text-lg lg:text-xl xl:text-2xl font-extrabold text-center py-2 md:py-5">Bogor</h4></div>
                <div><h4 className="text-sky-500 text-lg lg:text-xl xl:text-2xl font-extrabold text-center py-2 md:py-5">Depok</h4></div>
                <div><h4 className="text-sky-500 text-lg lg:text-xl xl:text-2xl font-extrabold text-center py-2 md:py-5">Tangerang</h4></div>
                <div><h4 className="text-sky-500 text-lg lg:text-xl xl:text-2xl font-extrabold text-center py-2 md:py-5">Bekasi</h4></div>
                <div><h4 className="text-sky-500 text-lg lg:text-xl xl:text-2xl font-extrabold text-center py-2 md:py-5">Surabaya</h4></div>
                <div><h4 className="text-sky-500 text-lg lg:text-xl xl:text-2xl font-extrabold text-center py-2 md:py-5">Malang</h4></div>
                <div><h4 className="text-sky-500 text-lg lg:text-xl xl:text-2xl font-extrabold text-center py-2 md:py-5">Bali</h4></div>
            </div>
        </div>
    );
}

export default SectionVisit;
